import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import WKTWriter from '../../io/WKTWriter';
import Coordinate from '../../geom/Coordinate';
import Double from '../../../../../java/lang/Double';
import Comparator from '../../../../../java/util/Comparator';
var IntervalRTreeNode = /*#__PURE__*/function () {
  function IntervalRTreeNode() {
    _classCallCheck(this, IntervalRTreeNode);
    IntervalRTreeNode.constructor_.apply(this, arguments);
  }
  _createClass(IntervalRTreeNode, [{
    key: "getMin",
    value: function getMin() {
      return this._min;
    }
  }, {
    key: "intersects",
    value: function intersects(queryMin, queryMax) {
      if (this._min > queryMax || this._max < queryMin) return false;
      return true;
    }
  }, {
    key: "getMax",
    value: function getMax() {
      return this._max;
    }
  }, {
    key: "toString",
    value: function toString() {
      return WKTWriter.toLineString(new Coordinate(this._min, 0), new Coordinate(this._max, 0));
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._min = Double.POSITIVE_INFINITY;
      this._max = Double.NEGATIVE_INFINITY;
    }
  }]);
  return IntervalRTreeNode;
}();
export { IntervalRTreeNode as default };
var NodeComparator = /*#__PURE__*/function () {
  function NodeComparator() {
    _classCallCheck(this, NodeComparator);
  }
  _createClass(NodeComparator, [{
    key: "compare",
    value: function compare(o1, o2) {
      var n1 = o1;
      var n2 = o2;
      var mid1 = (n1._min + n1._max) / 2;
      var mid2 = (n2._min + n2._max) / 2;
      if (mid1 < mid2) return -1;
      if (mid1 > mid2) return 1;
      return 0;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }]);
  return NodeComparator;
}();
IntervalRTreeNode.NodeComparator = NodeComparator;